import {ChangeDetectionStrategy, Component, HostListener, OnInit, inject} from '@angular/core';
import {Router, RouterOutlet} from '@angular/router';
import {AppVersionService} from './app-version.service';
import {ApiService} from './api.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App implements OnInit {
  readonly version = inject(AppVersionService);
  private readonly api = inject(ApiService);
  private readonly router = inject(Router);
  private sessionRefreshInFlight = false;

  ngOnInit() {
    this.version.start();
    this.renewValidSession();
  }

  @HostListener('window:focus')
  onWindowFocus() {
    this.version.check();
    this.renewValidSession();
  }

  @HostListener('window:storage', ['$event'])
  onStorageChange(event: StorageEvent) {
    if (event.key !== this.api.sessionStorageKey) return;
    this.api.syncSessionFromStorage();
    if (!this.api.isAuthenticated()) this.router.navigate(['/login']);
  }

  private renewValidSession() {
    if (this.sessionRefreshInFlight || !this.api.isAuthenticated()) return;
    this.sessionRefreshInFlight = true;
    this.api.refreshSession().subscribe({
      next: () => this.sessionRefreshInFlight = false,
      error: () => this.sessionRefreshInFlight = false
    });
  }
}
